var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Box, Link, Separator, Text } from "@chakra-ui/react";
export function NexusJobDisclaimer(_a) {
    var disclaimer = _a.disclaimer;
    return (_jsxs(Box, __assign({ "aria-label": "AI application summary disclosure", as: "section", mt: "24px" }, { children: [_jsx(Separator, { mb: "24px" }), _jsx(Text, { children: disclaimer.text }), _jsx(Text, __assign({ as: "h3", fontWeight: "bold", mt: "24px" }, { children: disclaimer.accommodationsHeading })), _jsx(Text, __assign({ mt: "12px" }, { children: disclaimer.accommodationsContent.map(function (part, index) {
                    var _a;
                    return part.href ? (_jsx(Link, __assign({ "aria-label": (_a = part.accessibleLabel) !== null && _a !== void 0 ? _a : undefined, href: part.href, textDecoration: "underline" }, { children: part.text }), index)) : (_jsx("span", { children: part.text }, index));
                }) }))] })));
}
